import { FC, useContext, useEffect } from 'react';
import { useGQLQuery } from 'hooks';
import { createGQLDataContext } from 'utils/createDataContext';
import { UseGQLQuery } from 'hooks/useGQLQuery/useGQLQuery.types';
import { ShiftModalOrderDetailsQuery } from 'types/graphql';
import { openShiftModalDetailsQueryConfig } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/OpenShiftModal.constants';
import { useRemovePositionModalUIContext } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/RemovePositionModal.ui.context';

export const OpenShiftModalDataContext = createGQLDataContext({});

export const OpenShiftModalDataProvider: FC = ({ children }) => {
  const { locationId, shift_id } = useRemovePositionModalUIContext();

  const facility_id = Number(locationId);
  const value = useGQLQuery<
    ShiftModalOrderDetailsQuery,
    ShiftModalOrderDetailsQuery,
    { id: number | undefined }
  >(openShiftModalDetailsQueryConfig(facility_id, shift_id));

  useEffect(() => {
    if (typeof shift_id === 'number') value.fetch();
  }, [shift_id]); // eslint-disable-line

  return (
    <OpenShiftModalDataContext.Provider value={value}>
      {children}
    </OpenShiftModalDataContext.Provider>
  );
};

export const useOpenShiftModalDataContext = (): UseGQLQuery<ShiftModalOrderDetailsQuery> =>
  useContext(OpenShiftModalDataContext);
